import { useCallback } from 'react';
import email_icon from '../assets/email_glyph.png';
import phone_icon from '../assets/phone_glyph.png';

export default function Footer({ navigationFunctions }) {
  // Function to handle navigation and update URL
  const handleNavigation = useCallback((path, e) => {
    e.preventDefault();
    navigationFunctions[path]();
  }, [navigationFunctions]);

  return (
    <footer className="site-footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-heading">Living Legend</h3>
            <p className="footer-tagline">Everybody's personal autobiographer</p>
            <div className="footer-contact">
              <p><a href="mailto:hello@yourlivinglegend.com"><img src={email_icon} alt="email" className="footer-contact-icon"/>hello@yourlivinglegend.com</a></p>
            </div>
          </div>
          
          <div className="footer-section">
            <h3 className="footer-heading">Navigation</h3>
            <ul className="footer-links">
              <li>
                <a href="/" onClick={(e) => handleNavigation('home', e)}>
                  Home
                </a>
              </li>
              <li>
                <a href="/give_gift" onClick={(e) => handleNavigation('give-gift', e)}>
                  Give a Gift
                </a>
              </li>
              <li>
                <a href="/redeem" onClick={(e) => handleNavigation('redeem', e)}>
                  Redeem a Gift
                </a>
              </li>
              <li>
                <a href="/choose_your_topic" onClick={(e) => handleNavigation('choose-your-topic', e)}>
                  Choose Your Topic
                </a>
              </li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h3 className="footer-heading">Legal</h3>
            <ul className="footer-links">
              <li><a href="/privacy">Privacy Policy</a></li>
              <li><a href="/terms">Terms of Service</a></li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Living Legend. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}